// extracted by mini-css-extract-plugin
export default {"button":"HeaderCardButton_button__uK1Y2","icon":"HeaderCardButton_icon__EdEeZ","text":"HeaderCardButton_text__i6QFP","badge":"HeaderCardButton_badge__Yfbit"};